<template>
    <LayoutPage>
        <template v-slot:banner>
            <BannerSmallerWithSearchAndButton
                :imageName="$t('UI.banners.smallerBannerImage')"
                :title="$t('favouritePage.title')"
                :description="$t('favouritePage.description')"
            />
        </template>
        <template v-slot:content>
            <LayoutPopular
                :themesRequestState="themesRequestState">
                <template v-slot:horizontalLinks>
                    <HorizontalScrollMenu
                        v-if="links"
                        :links="links"
                        :activeLink="activeLink"
                        :onClick="onLinkClick"
                    />
                </template>
                <template v-slot:links>
                    <SidebarLinks
                        v-if="links"
                        :links="links"
                        :activeLink="activeLink"
                        :onClick="onLinkClick"
                    />
                </template>
                <template v-slot:themes>
                    <div class="box box--left">
                        <Themes
                            v-if="themes"
                            :themes="themes"
                            :onThemeClick="onThemeClick"
                            containerClassName="row"
                            itemClassName="col-md-6 col-lg-6 col-xl-4 col-sm-6 col-xs-12"
                        />
                    </div>
                </template>
            </LayoutPopular>
        </template>
    </LayoutPage>
</template>

<script>

import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'
import SidebarLinks from '../components/ui/SidebarLinks';
import HorizontalScrollMenu from '../components/ui/HorizontalScrollMenu';
import LayoutPopular from '../components/layouts/Popular';
import Themes from '../components/ui/Themes';
import { openMapComposition, getThemesPromise } from '../services/MapsfyApi';
import LayoutPage from '@/components/layouts/Page';
import BannerSmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';

export default {
    components: {
        LayoutPopular,
        LayoutPage,
        BannerSmallerWithSearchAndButton,
        Themes,
        SidebarLinks,
        HorizontalScrollMenu
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
        this.loadData(this.links[0].geom);
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            themesRequestState: null,
            themes: null,
            activeLink: "id-all",
            links: [
                {
                    id: "id-all",
                    seo_id: "all-maps",
                    title: "Všetky mapy",
                    geom: "POLYGON((-152.9731131398373 -89.27151184440535,-157.19186323946806 -89.27151184440535,-157.19186323946806 89.8171706548372,-152.9731131398373 89.8171706548372,-152.9731131398373 -89.27151184440535))"
                },
                {
                    id: "id-world",
                    seo_id: "world",
                    title: "Svet",
                    geom: "POLYGON((-152.9731131398373 -89.27151184440535,-157.19186323946806 -89.27151184440535,-157.19186323946806 89.8171706548372,-152.9731131398373 89.8171706548372,-152.9731131398373 -89.27151184440535))"
                },
                {
                    id: "id-europe",
                    seo_id: "europe",
                    title: "Európa",
                    geom: "POLYGON((-20.604165171775044 29.47095181688802,24.13216294699781 29.47095181688802,24.13216294699781 58.24755080702445,-20.604165171775044 58.24755080702445,-20.604165171775044 29.47095181688802))"
                },
                {
                    id: "id-sk",
                    seo_id: "slovakia",
                    title: "Slovensko",
                    geom: "POLYGON((17.639069403496123 47.732445114360566,20.43508991092021 47.732445114360566,20.43508991092021 49.43469249275006,17.639069403496123 49.43469249275006,17.639069403496123 47.732445114360566))"
                },
                {
                    id: "id-cz",
                    seo_id: "czech-reublic",
                    title: "Česko",
                    geom: "POLYGON((12.047028388648842 48.995134113866456,14.843048896072931 48.995134113866456,14.843048896072931 50.65516603627192,12.047028388648842 50.65516603627192,12.047028388648842 48.995134113866456))"
                },
                {
                    id: "id-de",
                    seo_id: "germany",
                    title: "Německo",
                    geom: "POLYGON((5.268463936466982 49.34888274691711,10.860504951313992 49.34888274691711,10.860504951313992 52.58849337922552,5.268463936466982 52.58849337922552,5.268463936466982 49.34888274691711))"
                }
            ]
        };
    },
    methods: {
        onLinkClick(link) {
            this.activeLink = link.id;
            this.loadData(link.geom);
        },
        onThemeClick(theme) {
            //console.log('CLICKED THEME ', theme);
            this.$router.push({name: 'mapApp'});
            openMapComposition(theme.hash);
            /*
            setTimeout(() => {
            }, 100);
            */
        },
        loadData(bbox) {
            this.themesRequestState = "request";
            // eslint-disable-next-line
            getThemesPromise('popular', bbox)
                .then(res => {
                    this.themesRequestState = "success";
                    this.themes = res;
                })
                .fail(() => {
                    this.themesRequestState = "failure";
                });

        }
    }
}
</script>


<style lang="scss" scoped>
</style>
